export default "__VITE_ASSET___33SC6bb__"